import { Box } from '@mui/material';

export default function Forbidden() {
  return (
    <Box
      alignItems="center"
      display="flex"
      flex="1 1"
      flexDirection="column"
      justifyContent="center"
    >
      <Box fontSize="120px" fontWeight="700">
        Ошибка 403
      </Box>
      <Box fontSize="14px" marginTop="40px">
        У вас нет соответствующего доступа
      </Box>
    </Box>
  );
}
